import { render, staticRenderFns } from "./AttachmentItem.vue?vue&type=template&id=22f33eab&scoped=true&"
import script from "./AttachmentItem.vue?vue&type=script&lang=js&"
export * from "./AttachmentItem.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentItem.vue?vue&type=style&index=0&id=22f33eab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f33eab",
  null
  
)

export default component.exports